import React from 'react';

export default () => (
  <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
    <title>chart-symbol-triangle</title>
    <desc>Created with Sketch.</desc>
    <g id="chart-symbol-triangle" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon
        id="Polygon-Copy"
        fill="#CD3F39"
        fillRule="nonzero"
        points="6 0.5 12 10.8923048 2.07722728e-13 10.8923048"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/chart-symbol-triangle.es6.js